class MegaMenuImageHover {
  constructor(container) {
    this.container = container;
    this.imageContainer = container.querySelector('.megamenu-image-card__container');
    this.links = container.querySelectorAll('[data-hover-image]');
    this.images = container.querySelectorAll('.megamenu-image-card__item');
    this.defaultImage = container.querySelector('.megamenu-image-card__item[data-default="true"]');
    this.warmed = false;

    if (!this.imageContainer || !this.links.length) return;

    this.init();
  }

  init() {
    // Les visuels de survol n'ont plus de `src` a la construction de la page :
    // ils sont poses en `data-mm-*`. Vingt images de menu, soit environ 1,2 Mo,
    // partaient jusqu'ici sur CHAQUE page du site pour un panneau que le
    // visiteur n'avait pas encore ouvert — et dont une seule image est visible
    // a la fois. On les reveille au premier survol du menu, donc avant meme que
    // le panneau ait fini de s'ouvrir : le visiteur ne voit aucune difference.
    ['mouseenter', 'focusin', 'touchstart'].forEach(evt => {
      this.container.addEventListener(evt, () => this.warm(), { once: true, passive: true });
    });

    this.links.forEach(link => {
      link.addEventListener('mouseenter', () => { this.warm(); this.showImage(link); });
      link.addEventListener('focus', () => { this.warm(); this.showImage(link); });
    });

    this.container.addEventListener('mouseleave', () => this.resetImage());
  }

  /** Pose les `src` differes. Idempotent : un seul passage, quel que soit
   *  l'evenement qui declenche. */
  warm() {
    if (this.warmed) return;
    this.warmed = true;

    this.container.querySelectorAll('img[data-mm-src]').forEach(img => {
      if (img.dataset.mmSizes) img.sizes = img.dataset.mmSizes;
      if (img.dataset.mmSrcset) img.srcset = img.dataset.mmSrcset;
      img.src = img.dataset.mmSrc;
      img.removeAttribute('data-mm-src');
      img.removeAttribute('data-mm-srcset');
      img.removeAttribute('data-mm-sizes');
    });
  }

  showImage(link) {
    const imageId = link.getAttribute('data-hover-image');
    const targetImage = this.container.querySelector(`.megamenu-image-card__item[data-image-id="${imageId}"]`);
    if (!targetImage) return;

    this.images.forEach(img => img.classList.remove('active'));
    this.links.forEach(l => l.classList.remove('is-hovered'));

    targetImage.classList.add('active');
    link.classList.add('is-hovered');
  }

  resetImage() {
    if (!this.defaultImage) return;

    this.images.forEach(img => img.classList.remove('active'));
    this.links.forEach(l => l.classList.remove('is-hovered'));
    this.defaultImage.classList.add('active');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.megamenu-stanley').forEach(menu => new MegaMenuImageHover(menu));
});

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.megamenu-stanley').forEach(menu => new MegaMenuImageHover(menu));
  });
}

(function() {
  const triggers = document.querySelectorAll('li.has-megamenu.megamenu-stanley');
  if (!triggers.length) return;

  triggers.forEach(trigger => {
    let closeTimer = null;
    const CLOSE_DELAY = 300;
    const panel = trigger.querySelector('ul');

    function openMenu() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      trigger.classList.add('mega-is-open');
    }

    function scheduleClose() {
      closeTimer = setTimeout(() => {
        trigger.classList.remove('mega-is-open');
      }, CLOSE_DELAY);
    }

    trigger.addEventListener('mouseenter', openMenu);
    trigger.addEventListener('mouseleave', (e) => {
      if (trigger.contains(e.relatedTarget)) return;
      scheduleClose();
    });

    if (panel) {
      panel.addEventListener('mouseenter', openMenu);
      panel.addEventListener('mouseleave', (e) => {
        if (trigger.contains(e.relatedTarget)) return;
        scheduleClose();
      });
    }
  });
})();